import * as React from "react";
import Helper from "src/helper/Helper";
import HCLDX from "@system/config/hcldx";
import HelperAnalyticsEvent from "src/support/HelperAnalyticsEvent";

const NavigateToProductDetail = (props) => {
  const { SEOManufacturerName = "", SEOERPMFRPartNumber = "", ItemNumber = "", ERPPartNumber = "", searchTerm ,isTypeHead} = props?.data;

  const generateProductDetailUrl = () => {
    let newUrl = HCLDX.baseURL() + '/product';
    if (SEOManufacturerName) {
      newUrl += "/" + Helper.replaceSpecialChar(SEOManufacturerName?.toLowerCase());
    }
    if (SEOERPMFRPartNumber) {
      newUrl += "/" + Helper.replaceSpecialChar(SEOERPMFRPartNumber?.toLowerCase());
    }
    if (ItemNumber) {
      newUrl += "/" + ItemNumber.toLowerCase()
    }

    //  Removed the ItemNumber and ERPPartNumber query param #24358
    if (searchTerm) {
      newUrl += `?searchTerm=${searchTerm}`;
    } else {
      newUrl += "/"
    }

    return newUrl;
  };

  function typeHeadSearchEvent(e) {
    if (isTypeHead) {
      HelperAnalyticsEvent.typeHeadSearchEvent(searchTerm, 'Products', props.data?.SEOERPMFRPartNumber, generateProductDetailUrl());
    }
  }

  return (
    <>
      {SEOERPMFRPartNumber && (
        <a
          onClick={()=>typeHeadSearchEvent()}
          className="text-blue cursor-pointer text-wrap text-break bs5 d-inline-block"
          href={generateProductDetailUrl()}
          target={props?.target ? props?.target : "_self"}
        >
          {props.children}
        </a>
      )}
    </>
  );
};

export default NavigateToProductDetail;
